import { useMemo } from 'react';
import './style.scss';

interface IProps {
  hide?: boolean;
  isModernTemplate?: boolean;
}

const LOADING_MESSAGES = [
  // Clean & Premium
  'Preparing your next getaway…',
  'Loading your perfect vacation…',
  'Unlocking travel deals…',
  'One moment while we get things ready…',
  // Travel-Focused
  'Packing your dream trip…',
  'Exploring destinations for you…',
  'Finding the best places for your next adventure…',
  'Warming up the sunshine…',
  // Fast & Tech-Forward
  'Optimizing your travel experience…',
  'Setting up your personalized journey…',
  'Bringing travel to life…',
  // More Fun / Playful
  'Hang tight… paradise is loading.',
  'Your vacation vibes are on the way…',
  'Sunshine incoming…',
];

export function Loading(props: IProps) {
  const { hide, isModernTemplate } = props;

  // Get random message for modern template
  const loadingMessage = useMemo(() => {
    if (!isModernTemplate) {
      return null;
    }
    const randomIndex = Math.floor(Math.random() * LOADING_MESSAGES.length);
    return LOADING_MESSAGES[randomIndex];
  }, [isModernTemplate]);

  if (hide) {
    return null;
  }

  const shouldShowMessage = isModernTemplate && loadingMessage;

  return (
    <div className="w-100 h-100 preloader">
      <div id="loader" className="loader">
        <div className="loader-container">
          <div className="loader-icon text-center">
            <div className="imagecarousel">
            </div>
          </div>
        </div>
        {shouldShowMessage && (
          <div className="loader-message">
            <p className="loader-message__text">{loadingMessage}</p>
          </div>
        )}
      </div>
    </div>
  );

}
